module.exports = __webpack_public_path__ + "static/media/megaten.b080abea.png";